module.exports = __webpack_public_path__ + "img/down-arrow-dark-sharp.fe49cbf1.png";